/**
 * OrgDetail pure components.
 * These receive all data + mutations as props instead of fetching via tRPC,
 * making them usable in both the NextJS dashboard (tRPC wrapper) and the Chrome
 * extension (vanilla tRPC client + refresh signal).
 */

export { OrgDetailPageCore } from './OrgDetailPageCore';
export type { OrgDetailPageCoreProps } from './OrgDetailPageCore';

export { OrgInteractSectionPure } from './OrgInteractSectionPure';
export type { OrgInteractSectionPureProps } from './OrgInteractSectionPure';

export { OrgContactCardPure } from './OrgContactCardPure';

export { OrgSwitcherPure } from './OrgSwitcherPure';

export type {
  OrgDetailData,
  OrgDetailMutations,
  OrgTabId,
  OrgContactItem,
  OrgLocalContact,
  OrgLocalCadence,
  OrgContactCardUser,
  OrgField,
  OrgFieldName,
  OrgFlags,
  Stage,
} from './types';
